import React from 'react';
import {DOTS, usePagination} from "../../hooks/use-pagination";

interface PaginationsProps {
    onPageChange: (a: number) => void,
    totalCount: number,
    siblingCount?: number,
    currentPage: number,
    pageSize: number,
}
export const Pagination = (props: PaginationsProps) => {
    const {
        onPageChange,
        totalCount,
        siblingCount = 1,
        currentPage,
        pageSize
    } = props;

    const paginationRange = usePagination({
        currentPage,
        totalCount,
        siblingCount,
        pageSize
    });

    // If there are less than 2 times in pagination range we shall not render the component
    if (!paginationRange || currentPage === 0 || paginationRange.length < 2) {
        return null;
    }

    const onNext = () => {
        onPageChange(currentPage + 1);
    };

    const onPrevious = () => {
        onPageChange(currentPage - 1);
    };

    let lastPage = paginationRange[paginationRange.length - 1];
    return (
        <div className="col-xs-12 pagination-page-numbers">
            <div className="list-paginator pull-right">
                {/* Left navigation arrow */}
                {currentPage === 1 ? null : (
                    <div className="prev-paginator-button-wrapper">
                        <span className="paginator-button prev-paginator-button" onClick={onPrevious} />
                    </div>
                )}

                <div className="items-wrapper">
                    {paginationRange.map(pageNumber => {
                        // If the pageItem is a DOT, render the DOTS unicode character
                        if (pageNumber === DOTS) {
                            return (
                                <div key={'dots'} className="item-wrapper">
                                    <span className="paginator-item delimiter dots-item">..</span>
                                </div>
                            );
                        }

                        // Render our Page Pills
                        return (
                            <div key={pageNumber} className="item-wrapper">
                                <span className={`paginator-item ${pageNumber === currentPage ? 'active' : ''}`}
                                   onClick={() => onPageChange(pageNumber as number)}>{pageNumber}</span>
                            </div>
                        );
                    })}
                </div>

                {/*  Right Navigation arrow */}
                {currentPage === lastPage ? null : (
                    <div className="next-paginator-button-wrapper">
                        <span className="paginator-button next-paginator-button" onClick={onNext}/>
                    </div>
                )}
            </div>
        </div>
    );
};